import React, {useState, useEffect} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import "./Details.scss";
import {Loader} from "../../utils/Loader";
import Select from "../../components/Select/Select.tsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faCartPlus,
    faChevronDown,
    faHandHoldingHeart, faBoxOpen, faHandshake, faComments
} from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import ToastAddToBasket from "../../components/ToastAddToBasket/ToastAddToBasket";
import GoingBack from "../../components/GoingBack/GoingBack";
import ImageCarousel from "./ImagesCarrousel/ImageCarrousel";
import ProductItem from "../../components/ProductItem/ProductItem";
import mesurePoignet from "../../assets/mesure_poignet_2.jpg"

function DetailsProduct({cart, updateCart}) {
    const navigate = useNavigate();
    const {id} = useParams();

    const [isDataLoading, setDataLoading] = useState(false);
    const [productAdd, setProductAdd] = useState(false);
    const [isAddElement, setAddElement] = useState(false);
    const [produit, setProduit] = useState([]);
    const tableauObjet = Object.values(produit);
    const [selectedBraceletSize, setSelectedBraceletSize] = useState("");
    const [erreurChoixTaille, setErreurChoixTaille] = useState("");
    const [infosRemboursement, setInfosRemboursement] = useState(false);
    const [infosDescription, setInfosDescription] = useState(false);
    const [infosAnnesoNaturelle, setInfosAnnesoNaturelle] = useState(false);
    const [lieuFabrication, setLieuFabrication] = useState(false);
    const [selectedImage, setSelectedImage] = useState("");
    const [otherProducts, setOtherProducts] = useState([]);
    const jwtToken = Cookies.get("auth_token");

    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchData = async () => {
            setDataLoading(true);
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}products/${id}`
                );
                const product = await response.json();
                setProduit(Object.values(product));

                const getOtherProducts = async () => {
                    try {
                        const response = await fetch(
                            `${process.env.REACT_APP_API_URL}products/category/3products/${product[0].secondary_category}/${product[0].id}`
                        );
                        const products = await response.json();
                        setOtherProducts(products);
                    } catch (error) {
                        console.error(error);
                    }
                }
                getOtherProducts();
            } catch (error) {
                console.error(error);
            } finally {
                setDataLoading(false);
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        if (produit && produit.length > 0) {
            document.title = produit[0].name;
        }
    }, [produit]);

    const handleSizeChange = (event) => {
        setSelectedBraceletSize(event.target.value);
        if (event.target.value !== "") {
            setErreurChoixTaille("");
        }
    };

    function addToCart(cover, name, price, idProduct, idPrixStripe, secondary_category) {
        if (selectedBraceletSize === "" && secondary_category === "Bracelet") {
            setProductAdd(false);
            setDataLoading(false);
            setErreurChoixTaille("Veuillez choisir une taille de bracelet");
            return;
        }

        const panierInfos = {
            cover,
            name,
            price,
            idProduct,
            amount: 1,
            idPrixStripe,
            informationsComplementaires: secondary_category === "Bracelet" ? selectedBraceletSize : null,
        };

        if (jwtToken) {
            const insertInBasket = async () => {
                setDataLoading(true);
                try {
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}panier/insert`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${jwtToken}`
                            },
                            body: JSON.stringify({panierInfos}),
                        },
                    );

                    if (response.ok) {
                        const panier = await response.json();
                        updateCart(panier.contenuPanier);
                        const newAmount = panier.newAmount;
                        localStorage.setItem("nbElement", JSON.stringify(newAmount));
                        const nbArticles = JSON.parse(localStorage.getItem("nbArticles"));
                        localStorage.setItem("nbArticles", JSON.stringify(nbArticles + 1));
                    }
                } catch (error) {
                    console.error(error);
                } finally {
                    setProductAdd(true);
                    setDataLoading(false);
                }
            };
            insertInBasket();
        } else {
            const currentProductSaved = cart.find((product) =>
                product.idProduct === idProduct &&
                product.informationsComplementaires === selectedBraceletSize
            );

            if (currentProductSaved) {
                const updatedCart = cart.map((product) => {
                    if (product.idProduct === idProduct &&
                        product.informationsComplementaires === selectedBraceletSize) {
                        return {
                            ...product,
                            amount: product.amount + 1
                        };
                    }
                    return product;
                });
                updateCart(updatedCart);
            } else {
                const newProduct = {
                    cover,
                    name,
                    price,
                    idProduct,
                    amount: 1,
                    informationsComplementaires: secondary_category === "Bracelet" ? selectedBraceletSize : null,
                    idPrixStripe
                };
                updateCart([...cart, newProduct]);
            }

            const nbArticles = JSON.parse(localStorage.getItem("nbArticles")) || 0;
            localStorage.setItem("nbArticles", JSON.stringify(nbArticles + 1));
            setAddElement(true);
            setProductAdd(true);
        }
    }

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cart));
    }, [cart]);

    return (
        <div className="bodyElementDetails">
            {productAdd === true &&
                <ToastAddToBasket cart={cart} updateCart={updateCart} setProductAdd={setProductAdd}
                                  productAdd={productAdd}/>
            }
            {isDataLoading ? (
                <div className="loader-div">
                    <Loader/>
                </div>
            ) : (
                <>
                    <div className="div-going-back">
                        <GoingBack/>
                    </div>
                    
                    <div className="div-container-left-plus-right">
                        <div className="container-left-details">
                            {produit.map((produit) => (
                                <img
                                    key={produit.id}
                                    src={selectedImage === "" ? produit.covers[0] : selectedImage}
                                    alt={produit.name}
                                    id="image_produit"
                                />
                            ))}
                            <div style={{width: '100%', maxWidth: '500px'}}>
                                {produit.map((produit) => (
                                    <div key={produit.id}>
                                        <ImageCarousel images={produit.covers} setSelectedImage={setSelectedImage}/>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="details-list">
                            {produit.map((produit) => (
                                <div key={produit.id}>
                                    <h1>{produit.name}</h1>
                                    <h3>{produit.price.toFixed(2)} €</h3>

                                    {['Bracelet', 'Boucle Oreille', 'Accessoire'].includes(produit.secondary_category) && (
                                        <div style={{marginTop: "1.5rem"}}>
                                            <p style={{fontWeight: "600", color: "#334155"}}>Pierres présentes
                                                sur {produit.secondary_category === "Boucle Oreille" ? "les boucles d'oreilles" : produit.secondary_category === "Accessoire" ? "l'accessoire" : "le bracelet"} :
                                            </p>
                                            <ul style={{marginTop: "0.5rem"}}>
                                                {tableauObjet.map((p) => (
                                                    p.pierres.map((pierre, index) => (
                                                        <li key={index}>{pierre}</li>
                                                    ))
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {produit.secondary_category === "Bracelet" && (
                                        <>
                                            <div id="div-select_size_product">
                                                <select className="select-taille-bracelet"
                                                        value={selectedBraceletSize}
                                                        onChange={handleSizeChange}>
                                                    <option value="">Choisir taille de bracelet</option>
                                                    <option value="15 cm">15cm</option>
                                                    <option value="16 cm">16cm</option>
                                                    <option value="17 cm">17cm</option>
                                                    <option value="18 cm">18cm</option>
                                                    <option value="19 cm">19cm</option>
                                                    <option value="20 cm">20cm</option>
                                                    <option value="21 cm">21cm</option>
                                                    <option value="22 cm">22cm</option>
                                                    <option value="23 cm">23cm</option>
                                                    <option value="24 cm">24cm</option>
                                                </select>
                                            </div>
                                            {erreurChoixTaille && (
                                                <p style={{color: "#ef4444", fontSize: "0.9rem", margin: "0"}}>{erreurChoixTaille}</p>
                                            )}
                                        </>
                                    )}

                                    <button
                                        id="button_add_to_cart"
                                        onClick={() =>
                                            addToCart(produit.covers[0], produit.name, produit.price, produit.id, produit.idPrixStripe, produit.secondary_category)
                                        }
                                    >
                                        <FontAwesomeIcon icon={faCartPlus} size="lg" />
                                        Ajouter au panier
                                    </button>

                                    <div style={{marginTop: "2rem"}}>
                                        {/* Accordion Description */}
                                        <div className="accordion-item">
                                            <div className="accordion-header" onClick={() => setInfosDescription(!infosDescription)}>
                                                <h5>Description du produit</h5>
                                                <FontAwesomeIcon icon={faChevronDown} className={infosDescription ? "rotated" : ""} />
                                            </div>
                                            {infosDescription && (
                                                <div className="accordion-content">
                                                    {produit.description}
                                                </div>
                                            )}
                                        </div>

                                        {/* Accordion Remboursement */}
                                        <div className="accordion-item">
                                            <div className="accordion-header" onClick={() => setInfosRemboursement(!infosRemboursement)}>
                                                <h5>Satisfait ou remboursé</h5>
                                                <FontAwesomeIcon icon={faChevronDown} className={infosRemboursement ? "rotated" : ""} />
                                            </div>
                                            {infosRemboursement && (
                                                <div className="accordion-content">
                                                    Nous proposons une garantie de 14 jours sans risque. Si le produit ne vous convient pas pleinement, contactez-nous dans les 14 jours après sa réception. Nous nous efforcerons de vous satisfaire. Pour toute demande, utilisez notre page "Contact".
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {produit[0] && produit[0].secondary_category === "Bracelet" && (
                                <div style={{marginTop: "2rem"}}>
                                    <h5 style={{color: "#334155", fontSize: "1rem", fontWeight: "600", marginBottom: "1rem"}}>Guide taille poignet</h5>
                                    <img style={{borderRadius: "8px", objectFit: "cover", width: "100%", maxWidth: "400px"}}
                                         src={mesurePoignet} alt="guide taille poignet"/>
                                </div>
                            )}
                        </div>
                    </div>

                    {otherProducts.length > 0 && (
                        <div style={{marginTop: "3rem"}}>
                            <h2 style={{textAlign: "center", color: "#1e293b", fontSize: "1.75rem", marginBottom: "2rem"}}>Vous pourriez aimer ces produits</h2>
                            <div className="example-of-others-products">
                                {otherProducts.map(({id, covers, name, price, category, secondary_category, description, pierres}) => (
                                    <ProductItem
                                        key={id}
                                        id={id}
                                        covers={covers}
                                        name={name}
                                        price={price}
                                        description={description}
                                        category={category}
                                        secondary_category={secondary_category}
                                        pierres={pierres}
                                    />
                                ))}
                            </div>
                        </div>
                    )}

                    <div style={{marginTop: "4rem"}}>
                        <h2 style={{textAlign: "center", color: "#1e293b", fontSize: "1.75rem", marginBottom: "2rem"}}>Plus de détails sur notre marque</h2>
                        
                        <div className="main-div-infos-marque">
                            <div className="accordion-item">
                                <div className="accordion-header" onClick={() => setInfosAnnesoNaturelle(!infosAnnesoNaturelle)}>
                                    <h4>Qu'est-ce que Anne'so Naturelle ?</h4>
                                    <FontAwesomeIcon icon={faChevronDown} className={infosAnnesoNaturelle ? "rotated" : ""} />
                                </div>
                                {infosAnnesoNaturelle && (
                                    <div className="accordion-content">
                                        Anne'so Naturelle est une boutique où chaque bijou, conçu avec soin, rayonne d'authenticité. Découvrez nos bracelets faits main, empreints d'énergie naturelle. Chaque création reflète la beauté simple et la tranquillité. Plongez dans notre univers où la créativité rencontre le bien-être.
                                    </div>
                                )}
                            </div>

                            <div className="accordion-item" style={{borderBottom: 'none'}}>
                                <div className="accordion-header" onClick={() => setLieuFabrication(!lieuFabrication)}>
                                    <h4>Où sont fabriqués vos produits ?</h4>
                                    <FontAwesomeIcon icon={faChevronDown} className={lieuFabrication ? "rotated" : ""} />
                                </div>
                                {lieuFabrication && (
                                    <div className="accordion-content">
                                        Tous nos produits nécessitant une création à la main, sont fabriqués dans notre atelier.
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="div-banderole">
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <FontAwesomeIcon icon={faComments} size="2x"/>
                            <h4>À VOTRE ÉCOUTE</h4>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <FontAwesomeIcon icon={faHandHoldingHeart} size="2x"/>
                            <h4>FAIT À LA MAIN AVEC AMOUR</h4>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <FontAwesomeIcon icon={faBoxOpen} size="2x"/>
                            <h4 style={{textAlign: "center"}}>LIVRAISON GRATUITE DÈS 50€ D'ACHAT</h4>
                        </div>
                        <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                            <FontAwesomeIcon icon={faHandshake} size="2x"/>
                            <h4>SOUTENEZ L'ARTISANAT</h4>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default DetailsProduct;
